import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter} from "../../../utils/formatters";

class ProgramPriceList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "ProgramPriceList"}
                {...props}
                columns={{
                    "ticket_type": {
                        header: 'Típus',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "price": {
                        header: 'Ár',
                        width: 3,
                        sortable,
                        filterable,
                        className: 'currency',
                        renderer: CurrencyFormatter,
                    },
                    "group_price": {
                        header: 'Csoportos ár',
                        width: 3,
                        sortable,
                        filterable,
                        className: 'currency',
                        renderer: CurrencyFormatter,
                    },
                    "limit": {
                        header: 'x Fő-től',
                        width: 3,
                        sortable,
                        filterable
                    },
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default ProgramPriceList;
